var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "main",
      staticClass: "row v-grid1",
      staticStyle: { width: "100%", height: "100%" },
      attrs: { "data-grm-comp": "RoomCallMixing" },
    },
    [
      _vm.mixerConnState == "ready" ||
      _vm.mixerConnState == "connecting" ||
      _vm.loadingGroupMode
        ? _c("Loading")
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.secondVideo ||
                (!_vm.isScreenShareUserMe && _vm.mixerConnState == "connected"),
              expression:
                "secondVideo || (!isScreenShareUserMe && mixerConnState == 'connected')",
            },
          ],
          ref: "mixer_video_layer",
          staticClass: "mixer-video",
          staticStyle: {
            width: "100%",
            position: "absolute",
            left: "0",
            top: "0",
            "pointer-events": "none",
            "box-sizing": "border-box",
          },
          style: _vm.mixerVideoStyle,
          attrs: { "data-created-at": new Date() },
        },
        [
          _c("RoomVideo", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.secondVideo || !_vm.isMyScreenShare,
                expression: "secondVideo || !isMyScreenShare",
              },
            ],
            ref: "mixer_video",
            staticStyle: { width: "100%", height: "100%" },
            attrs: {
              "data-video-type": "mixer",
              muted: true,
              "data-created-at": new Date(),
            },
            on: { resize: _vm.onMixerVideoResize },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.mixerConnState == "connected",
              expression: "mixerConnState == 'connected'",
            },
          ],
          ref: "mixer_video_guide",
          staticClass: "mixer-video-guide",
          staticStyle: {
            width: "100%",
            height: "100%",
            position: "absolute",
            left: "0",
            top: "0",
            "box-sizing": "border-box",
          },
        },
        [
          _vm._l(_vm.roomUserVideos, function (ruv) {
            return _c("RoomCallMixingVideo", {
              key: ruv.id,
              ref: "videos_" + ruv.id,
              refInFor: true,
              attrs: {
                "video-rect": ruv,
                "mixer-video": true,
                rectObj: _vm.rectObj,
                videoOnly: _vm.videoOnly,
                secondVideo: _vm.secondVideo,
              },
            })
          }),
          _vm.isRoomMode("group")
            ? _c(
                "div",
                {
                  ref: "sub_group_layer",
                  staticClass: "sub-group-layer",
                  staticStyle: { position: "relative" },
                },
                _vm._l(_vm.roomGroups, function (roomGroup) {
                  return _c("RoomCallGroup", {
                    key: roomGroup.roomGroupId,
                    attrs: { "room-group": roomGroup },
                  })
                }),
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "mixer-video-guide-info",
              style: _vm.mixingVideoGuideInfo,
            },
            [
              _vm.ifMixerVideoPageWrapper
                ? _c("div", { staticClass: "mixer-video-page-wrapper" }, [
                    _c(
                      "div",
                      {
                        staticClass: "mixer-video-page-btn prev",
                        on: {
                          click: function ($event) {
                            return _vm.movePage(-1)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.pageInfo.curPageIndex + 1) +
                            "/" +
                            _vm._s(_vm.pageInfo.totalPageCount) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "mixer-video-page-btn next",
                        on: {
                          click: function ($event) {
                            return _vm.movePage(1)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.pageInfo.curPageIndex + 1) +
                            "/" +
                            _vm._s(_vm.pageInfo.totalPageCount) +
                            " "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ],
        2
      ),
      !_vm.secondVideo &&
      _vm.roomInfoSetting.useScreenMerger &&
      _vm.isRoomMode("screenShare") &&
      (_vm.isWebinarWall || (_vm.isWebinarLive && _vm.hasSpeakerRole()))
        ? _c(
            "GrmDraggableResizable",
            {
              attrs: {
                w: _vm.previewPip.width,
                h: _vm.previewPip.height,
                x: _vm.previewPip.x,
                y: _vm.previewPip.y,
                z: _vm.previewPip.z,
                "lock-aspect-ratio": _vm.previewPip.lockAspectRatio,
              },
            },
            [
              _c("RoomVideo", {
                ref: "localVideo",
                staticClass: "grm-video",
                attrs: { muted: true, videoOnly: _vm.videoOnly },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }